<template>
  <Entry/>
</template>
<script>
import Entry from './Entry.vue'
export default {
  components: {
    [Entry.name]: Entry
  }
}
</script>
